import { ITemple } from 'pages/apps/Temple/types';
import { TempleActionTypes } from './constants';

const INIT_STATE: State = {
    loading: false,
    results: [],
    templeDetailsById: null,
    isTempleCreated: false,
    isTempleUpdated: false,
};

type TempleActionType = {
    type:
        | TempleActionTypes.API_RESPONSE_SUCCESS
        | TempleActionTypes.API_RESPONSE_ERROR
        | TempleActionTypes.GET_TEMPLES
        | TempleActionTypes.GET_TEMPLE_DETAILS
        | TempleActionTypes.UPDATE_TEMPLE
        | TempleActionTypes.ADD_TEMPLE
        | TempleActionTypes.DELETE_TEMPLE
        | TempleActionTypes.RESET;

    payload: {
        actionType?: string;
        data?: any;
        error?: string;
    };
};

type State = {
    results: ITemple[];
    loading?: boolean;
    error?: string;
    templeDetailsById: ITemple | null;
    isTempleCreated: boolean;
    isTempleUpdated: boolean;
};

const Temples = (state: State = INIT_STATE, action: TempleActionType) => {
    switch (action.type) {
        case TempleActionTypes.API_RESPONSE_SUCCESS: {
            const { actionType, data } = action.payload;
            switch (actionType) {
                case TempleActionTypes.GET_TEMPLES: {
                    return {
                        ...state,
                        loading: false,
                        results: action.payload.data.results || action.payload.data,
                        isTempleCreated: false,
                        isTempleUpdated: false,
                    };
                }

                case TempleActionTypes.GET_TEMPLE_DETAILS:
                    return {
                        ...state,
                        templeDetailsById: ((data.temple || data) as ITemple) || null,
                        loading: false,
                    };

                case TempleActionTypes.UPDATE_TEMPLE: {
                    const updated = data as ITemple;
                    return {
                        ...state,
                        results: state.results.map((t) =>
                            t.id === updated.id ? updated : t
                        ),
                        isTempleUpdated: true,
                        loading: false,
                    };
                }

                case TempleActionTypes.ADD_TEMPLE: {
                    return {
                        ...state,
                        results: [data as ITemple, ...state.results],
                        templeDetailsById: data as ITemple,
                        isTempleCreated: true,
                        loading: false,
                    };
                }

                case TempleActionTypes.DELETE_TEMPLE: {
                    return {
                        ...state,
                        results: state.results.filter(
                            (temple) => temple.id !== data
                        ),
                        loading: false,
                    };
                }

                default:
                    return { ...state };
            }
        }
        case TempleActionTypes.API_RESPONSE_ERROR: {
            const { actionType, error } = action.payload;
            switch (actionType) {
                case TempleActionTypes.GET_TEMPLES: {
                    return {
                        ...state,
                        error: error,
                        loading: false,
                    };
                }
                case TempleActionTypes.GET_TEMPLE_DETAILS: {
                    return {
                        ...state,
                        error: error,
                        loading: false,
                    };
                }
                case TempleActionTypes.UPDATE_TEMPLE: {
                    return {
                        ...state,
                        error: error,
                        loading: false,
                    };
                }
                case TempleActionTypes.ADD_TEMPLE: {
                    return {
                        ...state,
                        error: error,
                        loading: false,
                    };
                }
                case TempleActionTypes.DELETE_TEMPLE: {
                    return {
                        ...state,
                        error: error,
                        loading: false,
                    };
                }
                default:
                    return { ...state };
            }
        }
        case TempleActionTypes.GET_TEMPLES:
            return { ...state, loading: true };
        case TempleActionTypes.GET_TEMPLE_DETAILS:
            return { ...state, loading: true };
        case TempleActionTypes.UPDATE_TEMPLE:
            return { ...state, loading: true };
        case TempleActionTypes.DELETE_TEMPLE:
            return { ...state, loading: true };
        case TempleActionTypes.RESET:
            return {
                ...INIT_STATE,
            };
        default:
            return { ...state };
    }
};

export default Temples;
